export function toggleAccordion(accordion) {
  accordion.addEventListener("click", (e) => {
    const accordionActive = document.querySelector(".accordion.active")
    const btnReadHoroscope = e.currentTarget.querySelector(".btn-read-horoscope")

    collapseAllAccordion()

    // เพิ่งยุบใบที่เปิดอยู่ — คำทำนายบางดาวยาวมาก ต้องเด้งกลับมาที่หัวการ์ด ไม่ให้ค้างกลางหน้า
    if (accordionActive === e.currentTarget) {
      e.currentTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
      return
    }

    accordion.classList.add("active")
    btnReadHoroscope.classList.add("active")
    btnReadHoroscope.innerHTML = 'ปิด <i class="fa-solid fa-chevron-up"></i>'
  })
}

function collapseAllAccordion() {
  const accordions = document.querySelectorAll(".accordion")
  const btnReadHoroscopes = document.querySelectorAll(".btn-read-horoscope")

  accordions.forEach((accordion) => {
    accordion.classList.remove("active")
  })

  btnReadHoroscopes.forEach((btnReadHoroscope) => {
    btnReadHoroscope.classList.remove("active")
    btnReadHoroscope.innerHTML = 'อ่าน <i class="fa-solid fa-chevron-down"></i>'
  })
}
